const eventStatus = {
  CasoCreado: 1,
  UsuarioAsignado: 2,
  CasoAnotado: 3,
  CambioEstatus: 4,
  EnvioNotificacion: 5,
  AnejoCreado: 6,
  AnejoEliminado: 7,
};

export const eventStatusIcon = Object.freeze({
  [eventStatus.CasoCreado]: 'fas fa-list-alt',
  [eventStatus.UsuarioAsignado]: 'fas fa-user-tag',
  [eventStatus.CasoAnotado]: 'fas fa-list-alt',
  [eventStatus.CambioEstatus]: 'fas fa-exchange',
  [eventStatus.EnvioNotificacion]: 'fas fa-list-alt',
  [eventStatus.AnejoCreado]: 'fas fa-file-plus',
  [eventStatus.AnejoEliminado]: 'fas fa-list-alt',
});

export default eventStatus;
